const NewsSectionLoading = () => (
  <section className="w-full py-12 sm:py-16 md:py-20 lg:py-32 xl:py-40">
    {/* 섹션 제목 스켈레톤 */}
    <div className="max-w-[1920px] mx-auto mb-8 lg:mb-16 px-[5%]">
      <div className="h-8 sm:h-9 md:h-10 lg:h-12 w-72 sm:w-80 md:w-96 bg-gray-200 animate-pulse rounded" />
    </div>

    {/* 슬라이더 스켈레톤 */}
    <div className="w-full flex flex-col md:flex-row">
      {/* 썸네일 이미지 스켈레톤 */}
      <div className="w-full md:w-[60%] max-w-[1200px] shrink-0 overflow-hidden">
        <div className="w-full aspect-video bg-gray-200 animate-pulse" />
      </div>

      {/* 게시글 목록 스켈레톤 */}
      <div className="flex flex-col flex-1 min-w-0 px-[2.5%] mt-6 md:mt-0 space-y-3">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="space-y-2 px-4 lg:px-8 py-4">
            <div className="h-4 w-3/4 bg-gray-200 animate-pulse rounded" />
            <div className="h-3 w-full bg-gray-200 animate-pulse rounded" />
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default NewsSectionLoading;
